<template>
	<div class="subbar" v-if="instance" style="background-color: #f7f5f9; min-height: 41px;">
		<div class="dF aC mb-0">
			<div class="breadcrumbs" style="align-items: center; display: block !important">
				<a-breadcrumb>
					<a-breadcrumb-item>{{
						instance.name
					}}</a-breadcrumb-item>
					<a-breadcrumb-item>{{
						selectedAppInitial
					}}</a-breadcrumb-item>
					<a-breadcrumb-item v-if="$route.params.id" style="color: var(--orange)">Edit
						Form/Survey</a-breadcrumb-item>
					<a-breadcrumb-item v-else-if="$route.path.includes('add')" style="color: var(--orange)">Add New
						Form/Survey</a-breadcrumb-item>
					<a-breadcrumb-item v-else style="color: var(--orange)">{{ formType }}</a-breadcrumb-item>
				</a-breadcrumb>
			</div>

			<div class="dF aC ml-auto d-none d-sm-flex">
				<template v-if="
					!$route.params.id &&
					!$route.path.includes('add') &&
					!$route.path.includes('settings')
				">
					<a-auto-complete style="width: 200px" placeholder=" Search for a form..."
						:dropdown-match-select-width="false" :dropdown-style="{ width: '300px' }"
						option-label-prop="value" @search="handleSearch" class="mr-4" size="large">
						<template slot="dataSource">
							<a-select-option @click="optionClicked(form)" v-for="(form, formI) in searchResult"
								:key="form + formI" :value="form.name + ` (${formI})`">
								<div class="dF aC">
									<div class="f1">
										<div>
											<strong>{{ form.name }}</strong>
										</div>
										<small class="text-sm">{{
											form.type
										}}</small>
									</div>
								</div>
							</a-select-option>
						</template>
						<a-input>
							<a-icon style="stroke: #000; stroke-width: 34" slot="prefix" type="search" />
						</a-input>
					</a-auto-complete>

					<div class="mr-4 d-none d-xl-block dash-divider" />
				</template>

				<a-button v-if="
					!$route.params.id &&
					!$route.path.includes('add') &&
					!$route.path.includes('settings')
				" @click="addNewForm" type="primary" icon="plus" size="large">
					ADD NEW
				</a-button>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			searchResult: [],
		};
	},
	computed: {
		selectedAppInitial() {
			return this.$store.state.theApp?.media?.initial || "FSC";
		},
		formType() {
			return this.$store.state.formType;
		},
		forms() {
			return Object.values(this.$store.state.forms.allForms);
		},
		instance() {
			return this.$store.state.instance;
		},
		appOptions() {
			return this.$store.state.forms.allSettings?.app?.options;
		},
	},
	methods: {
		addNewForm() {
			if (
				this.appOptions?.google_recaptcha &&
				this.appOptions.google_recaptcha.length
			) {
				this.$store.commit("SHOW_ADD_FORM");
			} else {
				this.$message.error(
					"Please set up your reCAPTCHA settings first before creating a new form."
				);
			}
		},
		optionClicked(data) {
			this.$router.push(`/edit/${data.id}`);
			this.$store.commit("SEARCH_SELECT", {});
			this.$store.commit("SEARCH_SELECT", data);
		},
		handleSearch(input) {
			if (input && input.length > 2) {
				this.searchResult = this.forms.filter(({ name }) => {
					const nameLower = name.toLowerCase();
					const inputLower = input.toLowerCase();
					return nameLower.includes(inputLower);
				});
			} else {
				this.searchResult = [];
			}
		},
	},
};
</script>
